import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { EMPTY_STRING, DEPLOY } from "../../../../constants";
import Spinner from "../../Spinner";
import Drawer, { selectSelectedDrawer } from "../../Drawer";
import { selectPipelineStatus } from "../../../../pages/DataModels";
import { actions as drawerActions } from "../../Drawer/drawers.reducers";
import { DeployLogRenderer } from "../../index";

const { FRONTEND, BACKEND } = DEPLOY;
const { setSelectedDrawer } = drawerActions;

const DeploymentLogsDrawer = () => {
  const dispatch = useDispatch();
  const selectedDrawer = useSelector(selectSelectedDrawer);
  const pipelineStatus = useSelector(selectPipelineStatus);

  const [expandedStep, setExpandedStep] = useState(EMPTY_STRING);

  // useEffect(() => {
  //   if (GCPDeploymentStatus === SUCCESS || AWSDeploymentStatus === SUCCESS) {
  //     let targetEndpoints = [];
  //     if (window.location.href.includes(MULESOFT))
  //       targetEndpoints = mulesoftEndpoints;
  //     else if (window.location.href.includes(DATA_MODALS))
  //       targetEndpoints = endpoints;
  //     targetEndpoints.forEach((endpoint) => {
  //       const endpointDeploymentInfo = {
  //         serviceId: endpoint.serviceId,
  //         deploymentInfo: {
  //           name: endpoint.name,
  //           url: endpoint.url,
  //           description: endpoint.description,
  //           method: endpoint.method,
  //           serviceId: endpoint.serviceId,
  //         },
  //       };
  //       const serviceDeploymentInfo = {
  //         deploymentInfo: {
  //           flow: endpoint.services.flow,
  //         },
  //       };
  //       dispatch(
  //         updateEndpoint({ id: endpoint.id, data: endpointDeploymentInfo })
  //       );
  //       dispatch(
  //         updateService({
  //           id: endpoint.services.id,
  //           data: serviceDeploymentInfo,
  //         })
  //       );
  //     });
  //   }
  // }, [
  //   AWSDeploymentStatus,
  //   GCPDeploymentStatus,
  //   dispatch,
  //   endpoints,
  //   mulesoftEndpoints,
  // ]);

  const handleClose = () => dispatch(setSelectedDrawer(null));

  return (
    <Drawer
      position="right"
      heading="Deployment Status & Logs"
      handleClose={handleClose}
      selectedDrawer={selectedDrawer}
      allowScrollBar={true}
    >
      <Spinner showSpinner={isEmpty(pipelineStatus)}>
        <div className="p-4">
          <div className="space-y-4">
            <div>
              {Object.keys(pipelineStatus).map((logs) => (
                <DeployLogRenderer
                  key={logs}
                  type={logs === FRONTEND ? FRONTEND : BACKEND}
                  setExpandedStep={setExpandedStep}
                  expandedStep={expandedStep}
                  logs={pipelineStatus[logs]}
                  shouldShowProgressBar={false}
                />
              ))}
            </div>
          </div>
        </div>
      </Spinner>
    </Drawer>
  );
};

export default DeploymentLogsDrawer;
